<template>
  <div
    :class="[
      'UIInputValidationWrapper',
      { 'UIInputValidationWrapper--has-errors': errors?.length },
    ]"
  >
    <div
      v-if="errors?.length && uiLib === 'flow'"
      class="UIInputValidationWrapper__error-flow"
    >
      <UIIcon name="closeCircle" /> {{ errors[0] }}
    </div>
    <slot />
    <div
      v-if="errors?.length && uiLib === 'dashlite'"
      class="UIInputValidationWrapper__error-dashlite"
    >
      {{ errors[0] }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import UIIcon from '../icons/UIIcon.vue'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  errors: string[]
  uiLib: 'dashlite' | 'flow'
}>()
</script>

<style scoped lang="scss">
.UIInputValidationWrapper {
  &--has-errors {
    --active-color: #{$color-ui-danger-main};
    --label-color: #{$color-ui-danger-main};
    --focus-shadow: 0 0 0 3px #{$color-ui-danger-10};

    & > * {
      border-color: var(--active-color) !important;
    }
  }
  &__error-flow {
    color: $color-ui-neutral-main;
    background-color: $color-ui-danger-10;
    padding: 0.25rem;
    border-radius: 0.5rem;
    font-size: 0.75rem;
    line-height: 1.25rem;
    margin-bottom: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;

    .UIIcon-wrapper {
      --color: #{$color-ui-danger-main};
      --size: 1.25rem;
    }
  }

  &__error-dashlite {
    font-size: 0.75rem;
    line-height: 1.25rem;
    color: $color-ui-danger-main;
    position: absolute;
    bottom: -1.25rem;
  }
}
</style>
